var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nuxt-link', {
    staticClass: "promo-banner",
    class: ("promo-banner_" + (_vm.sale.type)),
    attrs: {
      "to": _vm.saleLink
    }
  }, [_c('p', {
    staticClass: "promo-banner-text",
    class: ("promo-banner_" + (_vm.sale.type) + "-text")
  }, [_vm.sale.type === 'installment' ? [_vm._v("\n      Рассрочка "), _c('br'), _vm._v(" без переплат\n      "), _c('img', {
    attrs: {
      "src": require("assets/images/banners/installment.svg"),
      "alt": "Рассрочка без переплат"
    }
  })] : [_vm._v("\n      Выгодная подготовка к учебе\n      "), _c('img', {
    staticClass: "promo-banner__preparation-img promo-banner__preparation-img_desktop",
    attrs: {
      "src": require("assets/images/banners/vigodno_desktop.svg"),
      "alt": "Выгодная подготовка к учебе"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "promo-banner__preparation-img promo-banner__preparation-img_mobile",
    attrs: {
      "src": require("assets/images/banners/vigodno.svg"),
      "alt": "Выгодная подготовка к учебе"
    }
  })]], 2), _vm._v(" "), _vm.sale.type === 'installment' ? _c('p', {
    staticClass: "promo-banner__time"
  }, [_vm._v("\n    ДО 30.09.24\n  ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }